<script lang="ts" setup>
import { OhVueIcon } from 'oh-vue-icons'

interface Props {
  loading?: boolean
  big?: boolean
  sizeClass?: string
  icon?: string
}

withDefaults(defineProps<Props>(), {
  loading: false,
  big: false,
  icon: 'pr-spinner',
})
</script>

<template>
  <OhVueIcon
    v-if="loading"
    :class="
      sizeClass || {
        'w-5 h-5': !big,
        'w-10 h-10': big,
      }
    "
    class="animate-spin ml-2 text-neutral-300 dark:text-neutral-400"
    :name="icon"
  />
</template>
